import {createContext} from 'react';

const concursoContext = createContext();

export default concursoContext;